'use client';

import { Badge } from '@repo/ui/components/ui/badge';

interface TextValueProps {
  value: string | number;
  unit?: string;
}

export function TextValue({ value, unit }: TextValueProps) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm font-semibold text-foreground">{value}</span>
      {unit && (
        <Badge
          variant="secondary"
          className="whitespace-nowrap border-border/40 bg-muted/50 px-2 py-0.5 text-xs font-medium shadow-sm dark:border-border/30"
        >
          {unit}
        </Badge>
      )}
    </div>
  );
}

